import { render, staticRenderFns } from "./PackageApplicant.vue?vue&type=template&id=bdb6aa9e&"
import script from "./PackageApplicant.vue?vue&type=script&lang=js&"
export * from "./PackageApplicant.vue?vue&type=script&lang=js&"
import style0 from "./PackageApplicant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageApplicant.vue"
export default component.exports